/**
 *    @since: 2020-04-06
 *    @author: tams_dev1
 */
import resultFactory from '~/utils/resultFactory'
import {base64Decode} from '~/utils/base64'

export const state = () => ({
  // REST API
  txtDlpDataObjectUrl: '/api/op/dlp/data/predefined/objects',
  txtDlpUsrDataObjectUrl: '/api/op/dlp/data/userdefined/objects',
  txtDlpDataObjectCommitUrl: '/api/op/dlp/data',
  txtDlpObjectAllDataUrl: '/api/op/dlp/data/objects',
  txtDlpFileTypesUrl: '/api/op/dlp/filetype/types',
  getDlpDataObjectData: [],
  getDlpUsrDataObjectData: [],
  modifyDlpUsrDataObjectData: {
    dlp_data_obj_name: '', // (string)(not null)(range=0-32) DLP 데이터 객체
    dlp_data_obj_desc: '', // (string)(range=0-128) DLP 데이터 객체 설명,
    dlp_data_obj_use: 0, // (numeric)(range=0-1) DLP 데이터 객체 사용(0:미사용, 1:사용),
    dlp_data_obj_pre_def: 1, // (numeric)(not null)(range=1-1) DLP 데이터 유형(1:사용자),
    dlp_data_obj_add_info_value_type: 1, // (numeric)(range=1-4) DLP 데이터 객체 유형(1:문자열, 2:정규식, 3:크기, 4:파일유형),
    dlp_data_obj_add_info_value1: '', // (string)(range=0-385) DLP 데이터 객체 문자열/정규식 값(base64 encoding),
    dlp_data_obj_add_info_value2: '' // (string)(range=0-128) DLP 데이터 객체 크기/파일유형 값
  },
  getObjectAllData: [],
  fileTypeOption: [],
  basicRowSelectItems: [],
  userRowSelectItems: []
})

const getDataValue = (state, item) => {
  let txt = ''
  if (item.dlp_data_obj_add_info_value_type === 3) {
    txt = item.dlp_data_obj_add_info_value2
  } else if (item.dlp_data_obj_add_info_value_type === 4) {
    _.forEach(state.fileTypeOption, o => {
      if (item.dlp_data_obj_add_info_value2 === o.value) {
        txt = o.label
      }
    })
  } else {
    txt = base64Decode(item.dlp_data_obj_add_info_value1)
  }
  return txt
}

export const mutations = {
  clearStore: (state) => {
    state.getDlpDataObjectData = []
    state.getDlpUsrDataObjectData = []
    state.modifyDlpUsrDataObjectData = {}
    state.getObjectAllData = []
    state.fileTypeOption = []
    state.basicRowSelectItems = []
    state.userRowSelectItems = []
  },
  setBasicRowSelectItems: (state, data) => {
    state.basicRowSelectItems = _.cloneDeep(data)
  },
  setUserRowSelectItems: (state, data) => {
    state.userRowSelectItems = _.cloneDeep(data)
  },
  preDefineHeaderMutation: (state, data) => {
    state.getDlpDataObjectData = _.map(state.getDlpDataObjectData, (item) => {
      item.dlp_data_obj_use = data
      return item
    })
  },
  userDefineHeaderMutation: (state, data) => {
    state.getDlpUsrDataObjectData = _.map(state.getDlpUsrDataObjectData, (item) => {
      item.dlp_data_obj_use = data
      return item
    })
  },
  getObjectAllDataAction: (state, data) => {
    state.getObjectAllData = _.cloneDeep(data)
  },
  // 전체 조회는 데이터 초기화 추가/수정인 경우는 초기화 하지 않는다.
  getDlpDataObjectDataAction: (state, data) => { // 기본 데이터 객체 조회
    state.getDlpDataObjectData = _.cloneDeep(data)
  },
  getDlpUsrDataObjectDataAction: (state, data) => { // 사용자 정의 데이터 객체 조회
    state.getDlpUsrDataObjectData = _.map(data, (item) => {
      item.dlp_data_value = getDataValue(state, item)
      return item
    })
  },
  addDlpUsrDataObjectDataAction: (state, data) => {
    data.dlp_data_value = _.cloneDeep(getDataValue(state, data))
    state.getDlpUsrDataObjectData.push(data)
  },
  editDlpUsrDataObjectDataAction: (state, data) => {
    state.getDlpUsrDataObjectData = _.map(state.getDlpUsrDataObjectData, (item) => {
      if (item.dlp_data_obj_id === data.dlp_data_obj_id) {
        item = _.cloneDeep(data)
        item.dlp_data_value = getDataValue(state, item)
      }
      return item
    })
  },
  getFileTypeOption: (state, data) => {
    state.fileTypeOption = []
    if (data) {
      _.forEach(data, item => {
        state.fileTypeOption.push({label: item.dlp_data_obj_name, value: String(item.dlp_file_type_id)})
      })
    }
  }
}

export const actions = {
  // DLP 프로파일 > 데이터 객체
  async getObjectAllDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtDlpObjectAllDataUrl, '', {
        applyMsg: false,
        cancelMsg: false,
        successAlert: false,
        loading: false,
        loadingShow: false,
        loadingHide: false
      })
      return resultFactory(commit, {length: null, data: data, action: 'getObjectAllDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 기본 데이터 객체 조회
  async getDlpDataObjectDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtDlpDataObjectUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getDlpDataObjectDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 기본 데이터 객체 일괄수정
  async editDlpDataObjectListDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(state.txtDlpDataObjectUrl, {items: payload}, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 사용자 데이터객체 조회
  async getDlpUsrDataObjectDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtDlpUsrDataObjectUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getDlpUsrDataObjectDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 사용자 데이터 추가
  async addDlpUsrDataObjectDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(state.txtDlpUsrDataObjectUrl, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addDlpUsrDataObjectDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 사용자 데이터 수정
  async editDlpUsrDataObjectDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtDlpUsrDataObjectUrl}/${state.userRowSelectItems[0].dlp_data_obj_id}`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'editDlpUsrDataObjectDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 사용자 데이터 일괄수정
  async editDlpUsrDataObjectListDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(state.txtDlpUsrDataObjectUrl, {items: payload}, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async delDlpUsrDataObjectDataAction ({commit, state}) { // 사용자 정의 데이터 객체 삭제
    let isMulty = false
    const idList = []
    if (state.userRowSelectItems.length > 1) {
      isMulty = true
      state.userRowSelectItems.forEach((item) => {
        idList.push({'dlp_data_obj_id': item.dlp_data_obj_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(state.txtDlpUsrDataObjectUrl, {data: {items: idList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.txtDlpUsrDataObjectUrl}/${state.userRowSelectItems[0].dlp_data_obj_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.txtDlpDataObjectCommitUrl}/${type}`, null, msg)
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },

  async getFileTypeOption ({commit, state}) { // 사용자 정의 데이터 객체(데이터 값 row) 설정용 데이터
    try {
      const data = await this.$axios.$get(`${state.txtDlpFileTypesUrl}`)
      return resultFactory(commit, {length: null, data: data, action: 'getFileTypeOption', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
